<a [routerLink]="previousUrl">Return to previous</a>

<app-status-message/>